document.addEventListener('click', async function(e) {
  const btn = e.target.closest('.card-share-button');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const url = btn.dataset.productUrl;
  const title = btn.dataset.productTitle;

  if (navigator.share) {
    try {
      await navigator.share({
        title: title,
        url: url
      });
    } catch (err) {}
  } else if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(url);
      btn.classList.add('copied');
      setTimeout(() => btn.classList.remove('copied'), 1200);
    } catch (err) {}
  }
}, true);